import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";


const getAppointment = (clinicId,date="today")=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/dashboard-appointments?date="+date)
}

const getClinicInfo = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId)
}

const getActivity = (clinicId, pageNo=0, pageSize=50, query)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/activity?pageNo="+pageNo+"&pageSize="+pageSize+"&q="+query)
}

const getUserInfo = (clinicId,userid)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/users/"+userid)
}

const getUserByRole = (clinicId, role)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/users?role="+role)
}
const getUsers = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/users")
}
const getUpdateHistory = (clinicId,pageNo=0,pageSize=50)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/update-history?pageNo="+pageNo+"&pageSize="+pageSize)
}

const getReputationShortCode = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/reputation-enhancements")
}

const getReputationLink = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/reputation-enhancements/links")
}
const PatientComments = (clinicId,pageNo=0,pageSize=10)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/reputation-enhancements/comments?pageNo="+pageNo+"&pageSize="+pageSize)
}
const PatientFeedbacks = (clinicId,pageNo=0,pageSize=10)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/reputation-enhancements/feedbacks?pageNo="+pageNo+"&pageSize="+pageSize)
}
const getClinicActivity = (clinicId,pageNo=0,pageSize=10,query)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/activity?pageNo="+pageNo+"&pageSize="+pageSize+"&q="+query)
}

const clinicService = {
    getAppointment,
    getClinicInfo,
    getActivity,
    getUserInfo,
    getUserByRole,
    getUsers,
    getUpdateHistory,
    getReputationShortCode,
    getReputationLink,
    PatientComments,
    PatientFeedbacks,
    getClinicActivity
}

export default clinicService